import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import BrandSection from './components/BrandSection';
import CompareAgents from './components/CompareAgents';
import WhyChooseUs from './components/WhyChooseUs';
import CTASection from './components/CTASection';
import ArticleCards from './components/ArticleCards';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://cssspreadsheet.pics';

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "CSSBuy Spreadsheet",
  "url": siteUrl,
  "description": "The largest free CSSBuy spreadsheet directory with 3000+ verified links, trusted sellers, updated buying guides, shipping tips, and quality-checked recommendations for Kakobuy, Superbuy, and Oopbuy.",
  "publisher": {
    "@type": "Organization",
    "name": "CSSBuy Spreadsheet",
    "url": siteUrl,
    "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png"
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": siteUrl + "/search?q={search_term_string}"
    },
    "query-input": "required name=search_term_string"
  }
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <BrandSection />
        <CompareAgents />
        <WhyChooseUs />
        <CTASection />
        <ArticleCards />
        <Testimonials />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}